<template>
  <div class="fin-newsticker">
    <v-row>
      <v-col>
        <h2>Newsticker</h2>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi ex laborum magnam mollitia necessitatibus
        nisi obcaecati, provident quisquam quo quod repellat repudiandae. A ad adipisci dolor optio suscipit ullam.
        Aliquam beatae deleniti ducimus ea molestiae nobis optio tenetur veritatis voluptatibus? Accusamus aliquam,
        cumque, eaque earum esse eveniet expedita facere fuga, harum iure laboriosam libero molestias natus nisi nostrum
        obcaecati porro unde. A amet consectetur deleniti deserunt, eius eos, error, explicabo fugit iure minima nihil
        nobis officiis quisquam quod repellendus rerum sequi? A ad adipisci atque beatae blanditiis culpa, cum dolorem
        et ex excepturi impedit nihil quasi quia quidem vero voluptatem?
      </v-col>
      <v-col cols="3">
        Filterkomponente
      </v-col>
    </v-row>
  </div>

</template>

<script>
export default {
  name: 'fin-newsticker',
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>
